export class BatchOperationResponse {
    'successCount';
    'errorCount';
    'message';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "successCount",
            "baseName": "successCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "errorCount",
            "baseName": "errorCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchOperationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
